import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { TemplateVariable } from 'src/app/core/models/template-variables.model';

@Component({
  selector: 'app-variable-panel',
  templateUrl: './variable-panel.component.html',
  styleUrls: ['./variable-panel.component.scss']
})
export class VariablePanelComponent {

  @Input() variableOptions$: Observable<TemplateVariable[]>;
  @Input() loadingVariableOptions: boolean = false;
  @Input() variableInput$: Subject<string>;

  @Input() selectedTemplateVariable: TemplateVariable | null = null;
  @Output() selectedTemplateVariableChange = new EventEmitter<TemplateVariable | null>();

  @Output() variableChange = new EventEmitter<any>();
  @Output() addVariableClicked = new EventEmitter<void>();

  @Input() selectedVariables: TemplateVariable[] = [];
  @Output() removeVariable = new EventEmitter<TemplateVariable>();

  @Input() showCopyIcon: boolean = false;
  @Output() copyVariableToClipboard = new EventEmitter<TemplateVariable>();

  @Input() usedVariableKeys: string[] = [];
}


